import data from '../../data/datasets.js'
import {convertDate, fromDate} from './date.js'
import transform from './transform_history_data.js'
import './history-chart.tag'
import '../close-button.tag'

riot.tag2('station-infobox', '<close-button onclick="{close}"></close-button> <h3 class="infobox__title">{data.city}</h3> <section class="station-infobox__section"> <p>Messstelle: {data.mstbez}</p> <p>Letzte Messung:<br><strong>{data.value} mg</strong> am {convertDate(data.date)}</p> </section> <section class="station-infobox__section"> <h4>Entwicklung seit 2000</h4> <history-chart if="{data}" data="{transform(data.history)}" width="{root.parentNode.clientWidth - 40}"></history-chart> <div if="{exceeded.length > 0}"> <p>Der EU-Grenzwert von 50 mg wurde seit dem Jahr 2000 <strong class="exceeded">{exceeded.length} mal</strong> überschritten.</p> </div> <a class="city-link" onclick="{showCity}">Alle Stationen in {data.city}</a> </section>', '', 'if="{data}" class="infobox station-infobox {-visible: visible}"', function(opts) {

  this.data = false
  this.exceeded = []
  this.convertDate = convertDate
  this.fromDate = fromDate
  this.visible = false
  this.transform = transform

  riot.control.on(riot.EVT.updateStationInfobox, data => {
    const exceeded = data.history.filter(d => d[1] > 50)
    this.update({data, exceeded, visible: true})
  })

  riot.control.on(riot.EVT.hideStationInfobox, () => {
    this.update({visible: false})
  })

  this.close = () => {
    riot.control.trigger(riot.EVT.hideStationInfobox)
  }

  this.showCity = () => {
    const city = data.find(d => d.name === this.data.city)
    this.close()
    riot.control.trigger(riot.EVT.updateCityInfobox, city)
  }

});



// WEBPACK FOOTER //
// ./src/components/station-infobox/station-infobox.tag